import GoogleIcon from '@mui/icons-material/Google';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import React from 'react';
import { useSelector } from 'react-redux';
import { AppState } from '../../common/store/store';
import { MasterViewPage } from './MasterPage';


export const Auth = () => {

    const setAuthAfterUnothirizedAccess = useSelector((state: AppState) => state.device.authAfterUnothirizedAccess);
    return <MasterViewPage>
        <Container sx={{ textAlign: 'center', pt: 3, pb: 3 }}>
            <Box sx={{ pt: 10 }}>
                {setAuthAfterUnothirizedAccess ? <Alert severity='warning'>La page que vous tentez d'accéder est restreinte aux utilisateurs connectés uniquement. Veuillez vous connecter au site.</Alert> : null}
                <Typography variant='h1'>Connexion au site</Typography>
                <Typography><Button sx={{ m: 2 }} size='large' variant='contained' LinkComponent={'a'} href="/auth/google" startIcon={<GoogleIcon />}>Connexion à Google</Button></Typography>
                <Typography><a href="/auth/google/autrecompte">Se connecter à un autre compte google.</a></Typography>
            </Box>
        </Container>
    </MasterViewPage>;
};
